import { ShiftModalUIProvider } from 'modals/ShiftModal/ShiftModal.ui.context';
import { ShiftModalGlobalCacheDataProvider } from 'modals/ShiftModal/ShiftModalProvider.data.context';
import { ShiftModalComponent } from 'modals/ShiftModal/ShiftModal';
import { ShiftModalPropsProvider } from 'modals/ShiftModal/ShiftModal.props.context';

export const ShiftModal = () => {
  return (
    <ShiftModalUIProvider>
      <ShiftModalGlobalCacheDataProvider>
        <ShiftModalPropsProvider>
          <ShiftModalComponent />
        </ShiftModalPropsProvider>
      </ShiftModalGlobalCacheDataProvider>
    </ShiftModalUIProvider>
  );
};
